import { Component, Output, Input, EventEmitter, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HouseholdMember } from 'src/app/models/household-member';
import { CasesService } from 'src/app/services/cases.service';
import { Settings } from 'src/app/services/settings';
import { MatSort } from '@angular/material/sort';
import { MemberDto } from 'src/app/models/member-dto';

@Component({
	selector: 'app-duplicate-members',
	templateUrl: './duplicate-members.component.html',
	styleUrls: ['./duplicate-members.component.css']
})
export class DuplicateMembersComponent {
	strErr = '';
	public selectedRecord: HouseholdMember;
	public primaryRecord: MemberDto;
	public Idx: number | null = -1;
	public records: HouseholdMember[];
	public dataSource: MatTableDataSource<HouseholdMember>;
	public renderedData: Array<any>;
	public displayedColumns: string[] = ['select', 'firstName', 'middleName', 'lastName', 'dateOfBirth', 'gender', 'dateAdded'];
	public busyCursor: boolean = false;
	selectedOption = '';
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	duplicateKey: string;

	@Output() membersChanged = new EventEmitter();
	@Output() submitClicked = new EventEmitter();
	@Output() cancelClicked = new EventEmitter();
	constructor(private casesService: CasesService) {

	}

	public ngOnInit() {

	}
	public onShowHandler(member: MemberDto) {
		this.strErr='';
		this.primaryRecord = member;
		this.queryRecords();
	}
	queryRecords() {
		this.busyCursor = true;
		this.casesService.getAllDuplicateMembers(this.primaryRecord.duplicateKey,this.primaryRecord.memberId).subscribe(
			(result) => {
				this.records = result;
				this.dataSource = new MatTableDataSource(this.records);
				this.dataSource.sort = this.sort;
				this.busyCursor = false;
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve duplicate member details from the server');
				this.busyCursor = false;
			}
		);
	}

	getFormattedMemberName(primaryRecord: any): string {
		if (!primaryRecord) {
			return '';
		}
		const { firstName, middleName, lastName } = primaryRecord;
		return `${(firstName || '') + ' ' + (middleName || '') + ' ' + (lastName || '')}`.trim();
	}

	submitRecord() {
		this.strErr='';
		if (this.selectedOption === 'option1') {
			this.handleFirstOption();
		} else if (this.selectedOption === 'option2') {
			this.handleSecondOption();
		} else if (this.selectedOption === 'option3') {
			this.handleThirdOption();
		}
	}
	handleFirstOption() {
		const selectedMembers = this.records.filter(member => member.isSelected === true || member.isSelected === 1);
		if(selectedMembers.length>1){
			this.strErr='Only one record from table can be selected';
			return;
		}
		if(!selectedMembers || selectedMembers.length===0){
			this.strErr='Please select one record from table';
			return;
		}
		this.casesService.replaceCaseMemberWithAnotherMember(this.primaryRecord.memberId, selectedMembers[0].id, this.primaryRecord.caseId).subscribe(
			(result) => {
				this.submitClicked.emit();
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to update duplicate status');
			}
		);
	}
	handleSecondOption() {
		const selectedMembers = this.records.filter(member => member.isSelected === true || member.isSelected === 1);
		const selectedMemberIds = selectedMembers.map(member => member.id);
		if(!selectedMembers || selectedMembers.length===0){
			this.strErr='Please select one record from table';
			return;
		}
		this.casesService.replaceMatchingMembersWithDominantMemberRecord(selectedMemberIds,this.primaryRecord.memberId).subscribe(
			(result) => {
				this.submitClicked.emit();
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to update duplicate status');
			}
		);
	}
	handleThirdOption() {
		this.casesService.updateDuplicateStatusForMember(this.primaryRecord.memberId, null).subscribe(
			(result) => {
				this.submitClicked.emit();
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to update duplicate status');
			}
		);
	}
	cancelSubmitRecord() {
		this.cancelClicked.emit();
	}
}
